/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Glass
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../nls/StringResources',
	'lodash'
], function(StringResources, _) {

	class OpenMyPreferencesAction {

		constructor(options) {
			_.extend(this, options);
		}

		canExecute(context) {
			if (this.normalizeContext(context)) {
				return context.slideOutOptions !== undefined;
			}
			return false;
		}

		doAction(context) {
			if (!context) {
				return Promise.reject(new Error('No objects selected'));
			}
			this.normalizeContext(context);
			return this._doAction(context.slideOutOptions, context.glassContext);
		}

		normalizeContext(context) {
			if (context) {
				let launchPoint;
				try {
					const { items } = context.target.plugin.itemSpec;
					const { specItemIndex } = context.target;
					if (items !== null && specItemIndex !== null && items[specItemIndex]) {
						context.slideOutOptions = items[specItemIndex].options;
						launchPoint = context.target.plugin.getButtonElement();
					} else {
						context.slideOutOptions = context.options || this._findMyPreferencesDefaultOptions(context.itemSpec);
						launchPoint = context.$el;
					}
				} catch ( err ) {
					context.slideOutOptions = context.options || this._findMyPreferencesDefaultOptions(context.itemSpec);
					launchPoint = context.$el;
				}

				if (context.slideOutOptions) {
					context.slideOutOptions.launchPoint = launchPoint;
					context.slideOutOptions.label = StringResources.get('profileAndSettings');
					context.slideOutOptions.width = '400px';
				}
			}
			return context;
		}

		_doAction(slideOutOptions, glassContext) {
			let myPrefSlideOut;
			slideOutOptions.onHide = function() {
				myPrefSlideOut.contentView.hide();
			};
			myPrefSlideOut = glassContext.appController.showSlideOut(slideOutOptions);
			return Promise.resolve();
		}

		_findMyPreferencesDefaultOptions(itemSpec) {
			const items = itemSpec.items;
			const targetId = 'com.ibm.bi.glass.caPersonalMenu.accountSettings';
			let foundOptions;
			for (let i=0; i<items.length; i++) {
				if (targetId === items[i].id) {
					foundOptions = items[i].options;
					break;
				}
			}
			return foundOptions;
		}
	}

	return OpenMyPreferencesAction;
});
